import { useContext } from "react";
import { LocalizationContext } from "../provider/localization.provider";

const useLocalization = () => {
  const { localization, sendLocalizationCallback } =
    useContext(LocalizationContext);

  const setLanguage = (
    language: number,
    languageKey?: string,
    isRtl?: boolean
  ) => {
    sendLocalizationCallback &&
      sendLocalizationCallback({
        language,
        languageKey,
        isRtl,
      });
  };

  const getLanguage = () => {
    const { language, languageKey, isRtl } = localization || {};
    return { language, languageKey, isRtl };
  };

  const setCurrency = (currencyId: number, currencySymbol: string) => {
    sendLocalizationCallback &&
      sendLocalizationCallback({
        currencyId,
        currencySymbol,
      });
  };

  const getCurrency = () => {
    const { currencyId, currencySymbol } = localization || {};

    return { currencyId, currencySymbol };
  };

  return {
    setLanguage,
    getLanguage,
    getCurrency,
    setCurrency,
    sendLocalizationCallback,
    localization,
  };
};

export default useLocalization;
